// extracted by mini-css-extract-plugin
export var box = "Tooltip-module--box--8b293";
export var box_md = "Tooltip-module--box_md--b557a";
export var box_xmd = "Tooltip-module--box_xmd--e9bb7";
export var box_flex = "Tooltip-module--box_flex--5018c";
export var box_lg = "Tooltip-module--box_lg--9993d";
export var box_sm = "Tooltip-module--box_sm--ee357";
export var box_outer = "Tooltip-module--box_outer--4fd44";
export var box_whiteBg = "Tooltip-module--box_white-bg--88e09";
export var box_noMarginBottom = "Tooltip-module--box_no-margin-bottom--cfa63";
export var box_noPadding = "Tooltip-module--box_no-padding--ccae3";
export var box_outerGray = "Tooltip-module--box_outer-gray--1762e";
export var box_dark = "Tooltip-module--box_dark--633de";
export var box_zIndex = "Tooltip-module--box_z-index--dd30f";
export var box_zIndex6 = "Tooltip-module--box_z-index-6--54d7b";
export var box_eventsWithLine = "Tooltip-module--box_events-with-line--bbe78";
export var box_featuresAo = "Tooltip-module--box_features-ao--6bca7";
export var box_verticalPaddings = "Tooltip-module--box_vertical-paddings--169e4";
export var clearP = "Tooltip-module--clearP--2fbfa";
export var clearP_vc = "Tooltip-module--clearP_vc--784e6";
export var container = "Tooltip-module--container--55c87";
export var triangle = "Tooltip-module--triangle--dbe1c";
export var fadeInAnimation = "Tooltip-module--fadeInAnimation--61e3d";
export var placeHolderShimmer = "Tooltip-module--placeHolderShimmer--df06d";